var _g, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgB2BPrimaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "156px",
    height: "45px",
    viewBox: "0 0 156 45",
    enableBackground: "new 0 0 156 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M18.454,9.604v3.119h-1.179v-2.016H9.63V1.833h1.255v7.771h4.944V1.833h1.255v7.771H18.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M26.343,9.604v1.103h-6.44V1.833h6.263v1.103H21.17v2.726h4.45v1.078h-4.45v2.865H26.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M35.576,1.833v8.875h-1.268V6.752h-5.097v3.956h-1.268V1.833h1.268v3.816h5.097V1.833H35.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M44.265,2.936h-3.043v7.771h-1.242V2.936h-3.03V1.833h7.315V2.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M51.818,2.657c0.659,0.549,0.989,1.306,0.989,2.269c0,0.964-0.33,1.72-0.989,2.27 c-0.66,0.549-1.564,0.824-2.713,0.824h-2.193v2.688h-1.268V1.833h3.461C50.254,1.833,51.158,2.108,51.818,2.657z M50.905,6.403 c0.422-0.342,0.634-0.834,0.634-1.477c0-0.642-0.211-1.134-0.634-1.477c-0.423-0.342-1.035-0.514-1.838-0.514h-2.155v3.981h2.155 C49.87,6.917,50.482,6.746,50.905,6.403z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M12.724,23.033h-1.851v3.904H9.63v-8.875h1.243v3.854h1.876l2.789-3.854h1.356l-3.169,4.298l3.322,4.577 h-1.445L12.724,23.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M19.608,26.449c-0.719-0.393-1.283-0.936-1.693-1.629c-0.41-0.693-0.615-1.467-0.615-2.32 c0-0.854,0.205-1.627,0.615-2.32c0.41-0.693,0.974-1.236,1.693-1.629c0.718-0.393,1.525-0.589,2.421-0.589 c0.887,0,1.69,0.196,2.409,0.589c0.718,0.393,1.28,0.934,1.686,1.623c0.406,0.689,0.608,1.464,0.608,2.327 c0,0.862-0.203,1.637-0.608,2.326c-0.406,0.689-0.968,1.23-1.686,1.623c-0.719,0.394-1.521,0.59-2.409,0.59 C21.133,27.039,20.326,26.843,19.608,26.449z M23.785,25.467c0.52-0.296,0.93-0.703,1.229-1.224c0.3-0.52,0.45-1.101,0.45-1.743 c0-0.643-0.15-1.224-0.45-1.743c-0.3-0.52-0.71-0.928-1.229-1.224c-0.52-0.296-1.105-0.444-1.756-0.444 c-0.651,0-1.241,0.148-1.769,0.444c-0.528,0.296-0.943,0.704-1.243,1.224c-0.3,0.52-0.45,1.101-0.45,1.743 c0,0.642,0.15,1.223,0.45,1.743c0.3,0.521,0.714,0.928,1.243,1.224c0.528,0.296,1.118,0.443,1.769,0.443 C22.68,25.91,23.265,25.763,23.785,25.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M36.73,26.938l-0.013-6.466L33.51,25.86h-0.583L29.72,20.51v6.428h-1.217v-8.875h1.04l3.702,6.238 l3.651-6.238h1.04l0.013,8.875H36.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M48.552,26.938l-0.013-6.466l-3.208,5.389h-0.583l-3.208-5.351v6.428h-1.217v-8.875h1.04l3.702,6.238 l3.651-6.238h1.04l0.013,8.875H48.552z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M58.586,25.835v1.103h-6.44v-8.875h6.263v1.103h-4.995v2.726h4.45v1.078h-4.45v2.866H58.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M66.362,18.887c0.659,0.549,0.989,1.306,0.989,2.269c0,0.964-0.33,1.72-0.989,2.27 c-0.66,0.55-1.564,0.824-2.713,0.824h-2.193v2.688h-1.268v-8.875h3.461C64.798,18.063,65.702,18.338,66.362,18.887z M65.449,22.633 c0.422-0.342,0.634-0.834,0.634-1.477c0-0.642-0.211-1.134-0.634-1.477c-0.423-0.342-1.035-0.514-1.838-0.514h-2.155v3.98h2.155 C64.414,23.146,65.026,22.976,65.449,22.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M75.81,18.063v8.875h-1.255v-3.512c-0.938,0.363-1.805,0.545-2.599,0.545c-1.082,0-1.92-0.262-2.516-0.785 c-0.596-0.524-0.894-1.272-0.894-2.245v-2.878h1.243v2.738c0,0.66,0.2,1.167,0.602,1.521c0.401,0.355,0.97,0.533,1.705,0.533 c0.82,0,1.64-0.186,2.459-0.558v-4.234H75.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M84.634,25.835v1.103h-6.44v-8.875h6.263v1.103h-4.995v2.726h4.45v1.078h-4.45v2.866H84.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M87.794,26.449c-0.714-0.393-1.273-0.934-1.68-1.623c-0.405-0.688-0.608-1.464-0.608-2.326 c0-0.862,0.203-1.638,0.608-2.327c0.406-0.688,0.968-1.229,1.687-1.623c0.718-0.393,1.521-0.589,2.408-0.589 c0.693,0,1.327,0.116,1.902,0.349c0.574,0.232,1.064,0.577,1.471,1.033l-0.824,0.798c-0.668-0.701-1.501-1.052-2.498-1.052 c-0.659,0-1.255,0.148-1.787,0.444s-0.949,0.704-1.249,1.224c-0.3,0.52-0.45,1.101-0.45,1.743c0,0.642,0.15,1.223,0.45,1.743 c0.3,0.521,0.717,0.928,1.249,1.224s1.128,0.443,1.787,0.443c0.989,0,1.821-0.354,2.498-1.064l0.824,0.799 c-0.406,0.456-0.898,0.803-1.478,1.039c-0.579,0.237-1.215,0.355-1.908,0.355C89.31,27.039,88.509,26.843,87.794,26.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M98.149,23.033h-1.852v3.904h-1.242v-8.875h1.242v3.854h1.877l2.789-3.854h1.356l-3.17,4.298l3.322,4.577 h-1.445L98.149,23.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M105.033,26.449c-0.719-0.393-1.283-0.936-1.692-1.629c-0.41-0.693-0.615-1.467-0.615-2.32 c0-0.854,0.205-1.627,0.615-2.32c0.409-0.693,0.974-1.236,1.692-1.629c0.718-0.393,1.525-0.589,2.421-0.589 c0.888,0,1.69,0.196,2.409,0.589c0.718,0.393,1.28,0.934,1.687,1.623c0.405,0.689,0.608,1.464,0.608,2.327 c0,0.862-0.203,1.637-0.608,2.326c-0.406,0.689-0.969,1.23-1.687,1.623c-0.719,0.394-1.521,0.59-2.409,0.59 C106.559,27.039,105.751,26.843,105.033,26.449z M109.21,25.467c0.521-0.296,0.93-0.703,1.23-1.224 c0.3-0.52,0.449-1.101,0.449-1.743c0-0.643-0.149-1.224-0.449-1.743c-0.301-0.52-0.71-0.928-1.23-1.224 c-0.52-0.296-1.104-0.444-1.756-0.444c-0.65,0-1.24,0.148-1.769,0.444s-0.942,0.704-1.242,1.224c-0.3,0.52-0.45,1.101-0.45,1.743 c0,0.642,0.15,1.223,0.45,1.743c0.3,0.521,0.714,0.928,1.242,1.224s1.118,0.443,1.769,0.443 C108.105,25.91,108.69,25.763,109.21,25.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M113.928,18.063h1.255v6.846l5.249-6.846h1.166v8.875h-1.242v-6.833l-5.262,6.833h-1.166V18.063z  M116.14,16.992c-0.376-0.3-0.568-0.729-0.576-1.287h0.899c0.009,0.33,0.125,0.585,0.349,0.767 c0.225,0.182,0.535,0.272,0.933,0.272c0.38,0,0.687-0.091,0.919-0.272s0.353-0.438,0.361-0.767h0.888 c-0.009,0.549-0.201,0.976-0.577,1.28s-0.906,0.457-1.591,0.457C117.051,17.442,116.516,17.292,116.14,16.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M15.729,35.396h-3.043v7.771h-1.242v-7.771h-3.03v-1.103h7.315V35.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M23.548,42.064v1.103h-6.44v-8.874h6.263v1.103h-4.995v2.726h4.45v1.078h-4.45v2.865H23.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M26.24,34.293l2.32,3.245l2.32-3.245h1.483l-3.004,4.26l3.246,4.614h-1.496L28.56,39.63l-2.536,3.537 h-1.458l3.233-4.564l-3.017-4.31H26.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M41.634,34.293v8.874h-1.268v-3.955H35.27v3.955h-1.268v-8.874h1.268v3.815h5.097v-3.815H41.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M44.011,34.293h1.255v6.846l5.249-6.846h1.166v8.874h-1.242v-6.833l-5.261,6.833h-1.167V34.293z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M57.158,39.263h-1.851v3.904h-1.243v-8.874h1.243v3.854h1.876l2.789-3.854h1.356l-3.169,4.298l3.322,4.576 h-1.445L57.158,39.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M62.879,34.293h1.255v6.846l5.249-6.846h1.166v8.874h-1.242v-6.833l-5.261,6.833h-1.167V34.293z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.438,
    y: 1.396,
    fill: "#CCCCCC",
    width: 1.313,
    height: 42.208
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BPrimaryLogo);
export default ForwardRef;